
    import I18n from 'i18nObj';
    
      import 'translations/outcomes.criterion_header';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('outcomes.criterion_header');
  